var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isSignedIn ? _c('sign-in-dialog', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        _vm.$nextTick(function () {
          return _vm.isSignedIn || _vm.$emit('input', false);
        });
      }
    }
  }) : _c('dialog-scroll-lock', {
    attrs: {
      "width": "400",
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "ma-3",
    staticStyle: {
      "position": "absolute",
      "right": "0"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _vm.title ? _c('v-card-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm.isSubscriptionUpgrade && !_vm.global.profile.org_id && !_vm.org ? _c('v-card-subtitle', [_vm._v(" This plan includes access to the Ellacard business tools. Please create an organization account to continue. ")]) : _vm.subtitle ? _c('v-card-subtitle', {
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }) : _vm._e(), _vm.isSubscriptionUpgrade && !_vm.global.profile.org_id && _vm.org ? _c('v-card-subtitle', [_c('v-btn', {
    staticClass: "pl-2",
    attrs: {
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.org = null;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  }), _vm._v(" Organization details ")], 1)], 1) : _vm._e(), _vm.title || _vm.subtitle || _vm.isSubscriptionUpgrade && !_vm.global.profile.org_id && _vm.org ? _c('v-divider') : _vm._e(), !_vm.isSubscriptionUpgrade || _vm.global.profile.org_id || _vm.org ? [_c('v-card-text', {
    staticClass: "pt-5",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_vm.itemized ? [_c('div', {
    staticClass: "text-center text-h3 mb-5 py-3"
  }, [_c('price', {
    attrs: {
      "value": _vm.itemized.price,
      "per": _vm.metadataWithOrg.target == 'SUBSCRIPTION' ? 'year' : null
    }
  })], 1), _c('payment-btns', {
    staticClass: "mx-auto",
    attrs: {
      "itemized": _vm.itemized,
      "metadata": _vm.metadataWithOrg,
      "loading": _vm.isPaymentBtnsLoading,
      "progress": _vm.isPaymentInProgress
    },
    on: {
      "update:loading": function ($event) {
        _vm.isPaymentBtnsLoading = $event;
      },
      "update:progress": function ($event) {
        _vm.isPaymentInProgress = $event;
      },
      "price-update": _vm.onPriceUpdate,
      "complete": _vm.onComplete
    }
  })] : _vm._e()], 2), _vm.details ? [_c('v-divider'), _c('v-card-text', {
    staticClass: "caption font-italic pt-5",
    domProps: {
      "innerHTML": _vm._s(_vm.details)
    }
  })] : _vm._e()] : _vm._e(), _vm.isSubscriptionUpgrade ? _c('v-slide-x-transition', [!_vm.global.profile.org_id ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.org,
      expression: "!org"
    }],
    class: {
      absolute: _vm.org
    }
  }, [_c('v-card-text', {
    staticClass: "pt-5",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('org-sign-up-form', {
    ref: "org",
    attrs: {
      "hide-email": "",
      "hide-btns": ""
    }
  }), _c('div', {
    staticClass: "mt-6 text-right"
  }, [_c('v-btn', {
    staticClass: "pr-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.org = _vm.$refs.org.getOrgParams();
      }
    }
  }, [_vm._v(" Continue "), _c('v-icon', {
    staticClass: "ml-1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)], 1)], 1) : _vm._e()]) : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }